const Loading = () => {
  return (
    <div className='container'>
      <div className='loading'></div>
    </div>
  );
};
export default Loading;
